import { action, thunk } from "easy-peasy";
import { getAllUsers } from "../../services/users.service";

const usersModel = {
  // State
  users: [],
  usersLoading: false,
  usersError: null,
  lastDoc: null,
  hasMore: true,

  // Actions
  setUsers: action((state, payload) => {
    state.users = payload;
  }),

  appendUsers: action((state, payload) => {
    state.users = [...state.users, ...payload];
  }),

  setUsersLoading: action((state, payload) => {
    state.usersLoading = payload;
  }),

  setUsersError: action((state, payload) => {
    state.usersError = payload;
  }),

  setLastDoc: action((state, payload) => {
    state.lastDoc = payload;
  }),

  setHasMore: action((state, payload) => {
    state.hasMore = payload;
  }),

  resetUsers: action((state) => {
    state.users = [];
    state.lastDoc = null;
    state.hasMore = true;
    state.usersError = null;
  }),

  // Thunks
  fetchInitialUsers: thunk(async (actions) => {
    try {
      actions.setUsersLoading(true);
      actions.resetUsers();
      const { users, lastDoc, hasMore } = await getAllUsers({ lastDoc: null });
      actions.setUsers(users);
      actions.setLastDoc(lastDoc);
      actions.setHasMore(hasMore);
    } catch (err) {
      actions.setUsersError(err.message);
    } finally {
      actions.setUsersLoading(false);
    }
  }),

  fetchMoreUsers: thunk(async (actions, _, helpers) => {
    const { lastDoc, hasMore, usersLoading } = helpers.getState();
    if (!hasMore || usersLoading) return;
    try {
      actions.setUsersLoading(true);
      const {
        users,
        lastDoc: newLastDoc,
        hasMore: newHasMore,
      } = await getAllUsers({ lastDoc });
      actions.appendUsers(users);
      actions.setLastDoc(newLastDoc);
      actions.setHasMore(newHasMore);
    } catch (err) {
      actions.setUsersError(err.message);
    } finally {
      actions.setUsersLoading(false);
    }
  }),
};

export default usersModel;
